/* eslint-disable */
// @ts-nocheck
type INCOMPLETE_TYPE = 'incomplete';
type COMPLETE_TYPE = 'complete';
export type CompletionStatus = INCOMPLETE_TYPE | COMPLETE_TYPE;
export const INCOMPLETE: INCOMPLETE_TYPE = 'incomplete';
export const COMPLETE: COMPLETE_TYPE = 'complete';
export const DISABLED_STEP_INFO: string = 'All steps must be completed in order';
